import { Box, Container, Typography, Grid, Card, CardContent, Button } from "@mui/material"
import StarIcon from "@mui/icons-material/Star"
import PeopleIcon from "@mui/icons-material/People"
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser"
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"
import { useNavigate } from "react-router-dom"
import T from "../hooks/Language/T"

function Business() {
  const navigate = useNavigate()
  const handleGetStarted = () => {
    navigate("/businessinfo")
  }
  return (
    <T>
      <Container maxWidth='lg' sx={{ mt: 8, mb: 8 }}>
        {/* Hero Section */}
        <Box textAlign='center' mb={6}>
          <Typography variant='h2' fontWeight='bold' gutterBottom>
            Unlock Unlimited Growth
          </Typography>
          <Typography variant='h6' color='textSecondary' paragraph>
            Join our business package and gain access to limitless possibilities. Empower your team
            with unlimited credits, skills, and users. Let your business soar.
          </Typography>
          <Button variant='contained' color='primary' size='large' onClick={handleGetStarted}>
            Get Started Now
          </Button>
        </Box>

        {/* Features Section */}
        <Box mb={8}>
          <Typography variant='h4' fontWeight='bold' textAlign='center' gutterBottom>
            Business Package Benefits
          </Typography>
          <Grid container spacing={4} justifyContent='center'>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ textAlign: "center", p: 2 }}>
                <AccountBalanceIcon color='primary' sx={{ fontSize: 50 }} />
                <CardContent>
                  <Typography variant='h6' fontWeight='bold'>
                    Unlimited Credits
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Never worry about credit limits your growth is unlimited.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ textAlign: "center", p: 2 }}>
                <VerifiedUserIcon color='primary' sx={{ fontSize: 50 }} />
                <CardContent>
                  <Typography variant='h6' fontWeight='bold'>
                    Unlimited Skills
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Equip your team with an ever-growing set of skills.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ textAlign: "center", p: 2 }}>
                <PeopleIcon color='primary' sx={{ fontSize: 50 }} />
                <CardContent>
                  <Typography variant='h6' fontWeight='bold'>
                    Top Rated Users
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Find as many top rated users as you need.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ textAlign: "center", p: 2 }}>
                <StarIcon color='primary' sx={{ fontSize: 50 }} />
                <CardContent>
                  <Typography variant='h6' fontWeight='bold'>
                    Premium Support
                  </Typography>
                  <Typography variant='body2' color='textSecondary'>
                    Receive 24/7 priority support for all your needs.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        {/* Call to Action Section */}
        <Box textAlign='center' mt={6}>
          <Typography variant='h5' fontWeight='bold' gutterBottom>
            Ready to Take Your Business to the Next Level?
          </Typography>
        </Box>
      </Container>
    </T>
  )
}

export default Business
